<template>
  <div class="solfigrplyr solfigrplyr_add">
    <div class="solfigrplyr_left">
      <div class="d-flex position-relative">
        <div class="mdi mdi-account-plus solfigrplyr_add_icon"></div>
        <div class="solfigrplyr_name my-auto">Add Player</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SolfigrAddPlayer',
}
</script>

<style lang="scss" scoped>
.solfigrplyr {
  min-height: 0;
  min-width: 14.25rem;
  display: flex;
  gap: 0.5rem;
  background: var(--clr-black-1-3);
  padding: 0.5rem;
  cursor: pointer;
  gap: 1rem;
  border-radius: 4px;

  &_add {
    background: var(--clr-black-1-3);
    opacity: 0.7;
    transition: opacity 0.2s ease;

    &:hover {
      opacity: 1;
    }

    &_icon {
      width: 5.2rem;
      height: 5.2rem;
      background: var(--clr-black-0);
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      font-size: 2.5rem;
      color: var(--clr-primary);
    }
  }

  &_left {
    display: flex;
    flex-direction: column;
    min-width: 7rem;
  }

  &_name {
    font-size: 1rem;
    font-weight: 500;
    text-align: center;
    padding-left: 1rem;
  }
}
</style>
